import React from "react";

/**
 * Image Error Handling Hook
 * 
 * Manages failed images and provides fallback logic
 * Prevents infinite loading attempts for broken images
 */
export const useImageErrorHandling = () => {
  const [failedImages, setFailedImages] = React.useState<Set<string>>(new Set());
  
  const handleImageError = React.useCallback((imageSrc: string) => {
    setFailedImages(prev => new Set([...prev, imageSrc]));
  }, []);
  
  const isImageFailed = React.useCallback((imageSrc: string) => {
    return failedImages.has(imageSrc);
  }, [failedImages]);
  
  const resetImageError = React.useCallback((imageSrc: string) => {
    setFailedImages(prev => {
      const newSet = new Set(prev);
      newSet.delete(imageSrc);
      return newSet;
    });
  }, []);
  
  const clearAllErrors = React.useCallback(() => {
    setFailedImages(new Set());
  }, []);
  
  return {
    handleImageError,
    isImageFailed,
    resetImageError,
    clearAllErrors,
    failedImages: Array.from(failedImages),
  };
};
